import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSelect,{attrs:{"disabled":!_vm.isManager,"items":_vm.payrolls,"label":"Select Payroll"},on:{"change":_vm.getSelectedPayroll},model:{value:(_vm.selectedPayroll),callback:function ($$v) {_vm.selectedPayroll=$$v},expression:"selectedPayroll"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }